import { render, staticRenderFns } from "./viewReceivableStatement.vue?vue&type=template&id=500b0858&scoped=true&"
import script from "./viewReceivableStatement.vue?vue&type=script&lang=js&"
export * from "./viewReceivableStatement.vue?vue&type=script&lang=js&"
import style0 from "./viewReceivableStatement.vue?vue&type=style&index=0&id=500b0858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500b0858",
  null
  
)

export default component.exports